<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00043.installation.paraminstallation.title' | translate"
      [description]="
        'P00043.installation.paraminstallation.description' | translate
      "
    >
    </app-header-configuration>

    @if (showPositionModal()) {
      <app-information-title
        [title]="'P00043.parametre.sourcereference' | translate"
      ></app-information-title>

      <div class="my-3">
        <app-affichage-warning
          icon="fa-regular fa-exclamation-circle"
          [name]="'configuration.presentationmiseenservice.warning' | translate"
        ></app-affichage-warning>
      </div>

      <app-larged-link
        [name]="'P00043.configuration.sourceDebut' | translate"
        (onPress)="openPositionModal()"
      ></app-larged-link>

      <app-label-description
        [description]="
          'P00043.parametre.sourcereference.description' | translate
        "
      ></app-label-description>
    }

    <app-switch-configuration
      [title]="
        'P00043.installation.paraminstallation.comportementFiltration.title'
          | translate
      "
      [nameCustom]="
        'P00043.installation.paraminstallation.comportementFiltration.value'
          | translate
      "
      [value]="actionStack!.getValue('paIActivationPrioritePAC') !== 0"
      [description]="
        'P00043.installation.paraminstallation.comportementFiltration.description'
          | translate
      "
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PAC_Installation,
          'paIActivationPrioritePAC',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    <app-switch-configuration
      [title]="
        'P00043.installation.paraminstallation.autoMaintienFiltration.title'
          | translate
      "
      [nameCustom]="
        'P00043.installation.paraminstallation.autoMaintienFiltration.value'
          | translate
      "
      [value]="actionStack!.getValue('paIActivationAutoMaintien') !== 0"
      [description]="
        'P00043.installation.paraminstallation.autoMaintienFiltration.description'
          | translate
      "
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PAC_Installation,
          'paIActivationAutoMaintien',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
